import React from 'react';
import { useParams } from 'react-router-dom';
import ExamScoreTable from '@components/Component/Exams/ExamScoreTable';
import { Typography, Box } from '@mui/material';
import { useGetExamDetail } from '@components/Component/Exams/hooks/query';
import { useIsTeacher } from '@reducers/user/hooks';
import ShowIf from '@components/Atoms/ShowIf';
import ShadowScrollbars from '@components/Scrollbar';
import { PMSectionScores, usePMReportForExam } from '@components/Admin/PMOutcomes/PMOutcomeEmbed';
import Skeleton from '@components/Atoms/Skeleton/Skeleton';
import TestBreadcrumbsFilter from './TestBreadCrumbsFilter';
import { useGetActiveTestSession } from '../hooks';
import TestSessionScoresCard from './TestSessionScoresCard';

function TestSessionScores() {
  const { data: examDetails } = useGetExamDetail();
  const isTeacher = useIsTeacher();
  const { sectionId } = useParams();
  const testSession = useGetActiveTestSession();
  // PM exams show the properly calculated (Blooms-weighted) scores instead
  // of the raw score-table passthrough; everything else keeps the original
  // scaled-score card and table
  const { isPMExam, isLoading } = usePMReportForExam(isTeacher ? testSession?.exam?.id : undefined);
  const showPMScores = isTeacher && isPMExam;

  if (isLoading) {
    return <Skeleton height="24rem" width="100%" />;
  }

  return (
    <>
      <TestBreadcrumbsFilter currentPage="Scores" />
      <ShadowScrollbars style={{ height: 'calc(100vh - 4em)' }}>
        <Typography variant="h3" component="h1" sx={{ ml: 3 }}>
          Practice Test {(examDetails?.practice_test_order ?? 0) + 1} {showPMScores ? 'Scores' : 'Scaled Score'}
        </Typography>
        <ShowIf If={showPMScores}>
          <Box sx={{ mx: 3, mt: 2 }}>
            <PMSectionScores examId={testSession?.exam?.id} sectionId={parseInt(sectionId, 10)} />
          </Box>
        </ShowIf>
        <ShowIf If={!showPMScores}>
          <TestSessionScoresCard />
          <ShowIf If={isTeacher}>
            <ExamScoreTable />
          </ShowIf>
        </ShowIf>
      </ShadowScrollbars>
    </>
  );
}

export default TestSessionScores;
